import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> block into <head> for the lifetime of the
 * component. Each block is identified by `id` so it is idempotent even across
 * remounts, and gets removed on unmount so per-page schema doesn't leak.
 *
 * Usage:
 *   <StructuredData id="blog-post-article" data={{ "@context": "...", ... }} />
 */
export default function StructuredData({ id, data }) {
  const serialized = data ? JSON.stringify(data) : "";
  useEffect(() => {
    if (!id || !serialized) return undefined;
    const scriptId = `ld-json-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = serialized;
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, [id, serialized]);

  return null;
}
